// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root {
  margin: 0;
  padding: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: #282c34;
}

#root {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
}

main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
  background-color: #282c34;

  overflow-x: hidden;
  overflow-y: auto;
  margin-top: 1rem;
  margin-bottom: 1rem;
  box-sizing: border-box;
  width: min(600px, calc(100vw - 2rem));
  max-width: 600px;
}

textarea,
input[type="text"] {
  box-sizing: border-box;
  width: 340px;
  height: 50px;
  padding: 0;
  margin: 0;
  font-family: monospace;
  font-size: 16px;
  letter-spacing: 0.05rem;
  color: white;
  background-color: #282c34;
  text-align: center;
  line-height: 50px;
  resize: none;
  border: 1px solid white;
  border-radius: 0.25rem;
}

p {
  font-family: monospace;
  color: white;
  margin: 0;
  padding: 0;
  line-height: normal;
  word-break: break-all;
  margin-left: 1rem;
  margin-right: 1rem;
  font-size: 1rem;
}

button {
  font-size: 1rem;
  font-family: monospace;
  color: white;
  background-color: #282c34;
  border-radius: 0.25rem;
  border-width: 1px;
  border-color: white;
  box-shadow: none;
  padding-left: 1rem;
  padding-right: 1rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.15s ease-in-out;
}

button:hover {
  cursor: pointer;
}

button:not(.disabled):not(:disabled):hover {
  background-color: #3a4150;
}

button:not(.disabled):not(:disabled):active {
  border-style: inset;
}

button:focus-visible {
  outline: 2px solid #61dafb;
  outline-offset: 2px;
}

button.encrypt-btn {
  border-radius: 999px;
}

button.encrypt-btn:not(.disabled) {
  color: #282c34;
  background-color: white;
  border-color: white;
}

button.encrypt-btn:not(.disabled):not(:disabled):hover {
  background-color: #e8e8e8;
}

a {
  color: white;
}

label {
  font-size: 1rem;
  color: white;
  font-family: monospace;
  display: flex;
  flex-direction: row;
  gap: 0.2rem;
  align-items: center;
  justify-content: center;
}

.secret-ready {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 1.25rem;
  width: 100%;
  min-width: 0;
}

.secret {
  position: relative;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  width: 100%;
  margin: 0;
  background-color: #282c34;
  border: 1px solid white;
  padding-left: 2.75rem;
  padding-right: 2.75rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  text-align: center;
  border-radius: 0.25rem;
  font-family: monospace;
  font-size: 1rem;
  color: white;
}

.secret-value {
  white-space: pre-wrap;
  word-break: break-word;
}

.companion-message {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.65rem;
  max-width: 100%;
  color: white;
  font-family: monospace;
  font-size: 0.95rem;
  line-height: 1.45;
}

.companion-message p {
  margin: 0;
  text-align: center;
  white-space: pre-wrap;
  word-break: break-word;
}

button.message-copy-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.25rem;
  height: 1.25rem;
  padding: 0;
  border: none;
  background: transparent;
  color: #8a919e;
  font-size: 0.95rem;
  line-height: 1;
}

button.message-copy-btn:not(:disabled):hover {
  background-color: transparent;
  color: white;
}

button.secret-eye-btn {
  position: absolute;
  right: 0.6rem;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: none;
  border-radius: 0.25rem;
  background-color: transparent;
  color: white;
  opacity: 0.7;
  font-size: 1.1rem;
  cursor: pointer;
  transition: opacity 0.15s ease-in-out, background-color 0.15s ease-in-out;
}

button.secret-eye-btn:not(:disabled):hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.12);
}

button.secret-eye-btn:focus-visible {
  opacity: 1;
  outline: 2px solid #61dafb;
  outline-offset: 1px;
}

.secret-lock-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes lockJump {
  0% {
    transform: translateY(0);
  }
  40% {
    transform: translateY(-7px);
  }
  70% {
    transform: translateY(0);
  }
  85% {
    transform: translateY(-2px);
  }
  100% {
    transform: translateY(0);
  }
}

.secret-lock-jump {
  animation: lockJump 0.32s ease-out;
}

@media (prefers-reduced-motion: reduce) {
  .secret-lock-jump {
    animation: none;
  }
}

.masked {
  /* color: #8a919e;
  border-color: #8a919e; */
}

.radio-group {
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.radio-group label.expiration {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1rem;
  border-width: 1px;
  border-style: outset;
  border-color: #8a919e;
  border-radius: 999px;
  background-color: #282c34;
  color: #8a919e;
  font-family: monospace;
  font-size: 1rem;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  transition: color 0.15s ease-in-out, border-color 0.15s ease-in-out;
}

.radio-group input[type="radio"].expiration {
  position: absolute;
  opacity: 0;
  pointer-events: none;
  width: 0;
  height: 0;
}

.radio-group label.expiration svg.time-joker {
  fill: currentColor;
}

.radio-group label.expiration:has(input[type="radio"]:checked) {
  color: #282c34;
  background-color: white;
  border-color: white;
  border-style: solid;
}

.radio-group label.expiration:has(input[type="radio"]:focus-visible) {
  outline: 2px solid #61dafb;
  outline-offset: 2px;
}

@media (max-width: 768px) {
  /* Tablets */
  textarea {
    width: 400px;
  }
}

@media (max-width: 480px) {
  /* Mobile */
  textarea {
    width: 300px; /* Full width on very small screens */
  }
}

.back-to-future-title {
  font-family: "Press Start 2P", cursive; /* Retro pixel font */
  font-size: 2rem;
  color: #f5f5f5; /* Light color for text */
  /* text-shadow: 2px 2px 5px rgba(0, 0, 255, 0.2); */
  /* text-shadow: 0 0 10px rgba(255, 255, 255, 0.8),
    0 0 20px rgba(255, 255, 255, 0.6), 0 0 30px rgba(255, 255, 255, 0.4),
    0 0 40px rgba(0, 255, 255, 0.6), 0 0 50px rgba(0, 255, 255, 0.4),
    0 0 60px rgba(0, 255, 255, 0.2);
  background: linear-gradient(45deg, #ff00ff, #00ffff, #ff0000);
  background-clip: text;
  -webkit-background-clip: text; */
  /* animation: neon 1.5s ease-in-out infinite alternate; */
}

@keyframes neon {
  0% {
    text-shadow: 0 0 5px rgba(255, 255, 255, 0.8),
      0 0 10px rgba(255, 255, 255, 0.6), 0 0 15px rgba(255, 255, 255, 0.4),
      0 0 20px rgba(0, 255, 255, 0.6);
  }
  100% {
    text-shadow: 0 0 20px rgba(255, 255, 255, 0.8),
      0 0 30px rgba(255, 255, 255, 0.6), 0 0 40px rgba(255, 255, 255, 0.4),
      0 0 50px rgba(0, 255, 255, 0.6);
  }
}

h1 {
  margin: 0;
}

.brand {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
}

.tagline {
  margin: 0;
  font-family: monospace;
  font-size: 0.9rem;
  color: #8a919e;
}

.link-ready-copy {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.85rem;
  margin-top: 1.25rem;
}

.link-ready-title,
.link-ready-subtitle,
.expires-after {
  margin: 0;
  font-family: monospace;
  text-align: center;
}

.link-ready-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  color: white;
  font-size: 1rem;
}

.link-ready-title svg {
  color: #3dd68c;
}

.secret-ready-title svg {
  color: inherit;
}

.link-ready-subtitle,
.expires-after {
  color: #8a919e;
  font-size: 0.9rem;
}

.expires-after {
  display: flex;
  align-items: center;
  gap: 0.45rem;
}

.link-ready {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 1.25rem;
  width: 100%;
  min-width: 0;
}

.share-link {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0.75rem;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 0.75rem;
  border: 1px solid white;
  border-radius: 0.25rem;
}

.share-link-url {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 0 0.25rem;
  color: white;
  font-family: monospace;
  font-size: 0.85rem;
  line-height: 1.4;
  text-align: left;
  word-break: break-all;
}

.share-link-url svg {
  flex-shrink: 0;
  margin-top: 0.15rem;
}

.share-link button.encrypt-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  width: 100%;
}

.copy-secret {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 0.85rem;
  width: 100%;
}

.retrieve-error {
  display: flex;
  flex-direction: column;
  align-items: center;
  align-self: stretch;
  gap: 1rem;
  width: 100%;
  min-width: 0;
}

.retrieve-error-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border: 1px solid #8a919e;
  border-radius: 999px;
  color: #c5cad3;
  font-size: 1.15rem;
}

.retrieve-error-title {
  margin: 0;
  color: #f5f5f5;
  font-family: monospace;
  font-size: 1rem;
  font-weight: 400;
  text-align: center;
}

.retrieve-error-text {
  max-width: 28rem;
  margin: 0;
  color: #8a919e;
  font-family: monospace;
  font-size: 0.9rem;
  line-height: 1.5;
  text-align: center;
  text-wrap: balance;
  word-break: normal;
  overflow-wrap: break-word;
}

button.retrieve-error-action {
  align-self: center;
  width: auto;
  border-radius: 999px;
  border-color: #8a919e;
  background-color: #282c34;
}

button.create-another-btn,
button.copy-secret-btn,
a.mailto-secret-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  align-self: stretch;
  width: 100%;
  border-radius: 999px;
}

a.mailto-secret-btn {
  box-sizing: border-box;
  border-style: outset;
  border-width: 1px;
  border-color: white;
  background-color: #282c34;
  color: white;
  font-family: monospace;
  font-size: 1rem;
  padding: 0.5rem 1rem;
  text-decoration: none;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.15s ease-in-out;
}

a.mailto-secret-btn:hover {
  background-color: #3a4150;
}

a.mailto-secret-btn:focus-visible {
  outline: 2px solid #61dafb;
  outline-offset: 2px;
}

@keyframes scaleUpReveal {
  0% {
    transform: scale(0.9);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

/* Isolated class for the effect */
.scale-up-reveal {
  opacity: 0;
  animation: scaleUpReveal 0.3s ease-in-out forwards;
}

@keyframes slideInLeft {
  0% {
    transform: translateX(-20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Isolated class for the effect */
.slide-in-left {
  opacity: 0;
  animation: slideInLeft 0.3s ease-in-out forwards;
}

@keyframes slideInRight {
  0% {
    transform: translateX(20px);
    opacity: 0;
  }
  100% {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Isolated class for the effect */
@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes slideOutRight {
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(20px);
  }
}

.slide-in-right {
  animation: slideInRight 0.3s ease-in-out forwards;
}

.slide-out-right {
  animation: slideOutRight 0.3s ease-in-out forwards;
}

.tiny-text {
  font-size: 0.75rem;
}

.zoom-on-click {
  -webkit-user-select: none;
          user-select: none; /* Prevent text selection */
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
}

.zoom-on-click:active {
  transform: scale(1.1); /* Slight zoom on click */
}

.disabled {
  pointer-events: none;
  color: #8a919e;
  border-color: #8a919e;
}

.button-group {
  display: flex;
  flex-direction: row;
  gap: 1rem;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: stretch;
  align-self: stretch;
  width: 100%;
  box-sizing: border-box;
}

.secret-fields {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  width: 100%;
}

.input-wrapper textarea {
  width: 100%;
  min-width: 0;
  height: calc(4 * 1.45em + 1.6rem + 2px);
  min-height: calc(4 * 1.45em + 1.6rem + 2px);
  padding: 0.8rem 2.6rem;
  line-height: 1.45;
  text-align: center;
  resize: vertical;
}

.input-wrapper textarea:placeholder-shown,
.input-wrapper textarea.single-line {
  padding-top: calc((3 * 1.45em + 1.6rem) / 2);
  padding-bottom: calc((3 * 1.45em + 1.6rem) / 2);
}

.input-wrapper:has(.input-clear-btn) textarea {
  padding-left: 4.5rem;
  padding-right: 4.5rem;
}

.message-field {
  display: flex;
  align-self: stretch;
  width: 100%;
}

.message-field input[type="text"] {
  width: 100%;
  min-width: 0;
  height: 50px;
  padding: 0 0.85rem;
  line-height: 50px;
}

.char-count {
  position: absolute;
  right: 0;
  bottom: calc(100% + 0.3rem);
  font-family: monospace;
  font-size: 0.7rem;
  line-height: 1;
  color: #8a919e;
  pointer-events: none;
  -webkit-user-select: none;
          user-select: none;
  white-space: nowrap;
}

button.input-clear-btn,
button.input-dice-btn {
  position: absolute;
  top: 0.65rem;
  transform: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  padding: 0;
  border: none;
  border-radius: 0.25rem;
  background-color: transparent;
  color: white;
  opacity: 0.6;
  font-size: 0.9rem;
  cursor: pointer;
  transition: opacity 0.15s ease-in-out, background-color 0.15s ease-in-out;
}

button.input-dice-btn {
  right: 0.4rem;
}

button.input-clear-btn {
  right: 2.3rem;
}

button.input-clear-btn:not(:disabled):hover,
button.input-dice-btn:not(:disabled):hover {
  opacity: 1;
  background-color: rgba(255, 255, 255, 0.12);
}

button.input-clear-btn:focus-visible,
button.input-dice-btn:focus-visible {
  opacity: 1;
  outline: 2px solid #61dafb;
  outline-offset: 1px;
}

.icon-button {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  padding: 0;
  font-size: 1rem;
  flex-shrink: 0;
}

.link {
  width: 300px;
}

.recent-links {
  align-self: stretch;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  width: 100%;
}

.recent-links-header {
  display: flex;
  align-items: baseline;
  justify-content: flex-start;
  gap: 1rem;
}

.recent-links h2 {
  margin: 0;
  color: #8a919e;
  font-family: monospace;
  font-size: 0.75rem;
  font-weight: 400;
  letter-spacing: 0.04em;
}

.recent-links ul {
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  list-style: none;
}

.recent-links li {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  min-height: 1.75rem;
  color: white;
  font-family: monospace;
  font-size: 0.8rem;
}

.recent-time,
.recent-expiration {
  color: #8a919e;
}

.recent-time {
  font-variant-numeric: tabular-nums;
}

button.recent-text-btn,
button.recent-remove-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.3rem;
  padding: 0.15rem 0.25rem;
  border: none;
  background: transparent;
  color: #8a919e;
  font-size: 0.75rem;
  line-height: 1;
}

button.recent-remove-btn {
  width: 1.25rem;
  height: 1.25rem;
  padding: 0;
}

button.recent-text-btn:not(:disabled):hover,
button.recent-remove-btn:not(:disabled):hover {
  background-color: transparent;
  color: white;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;;EAGE,SAAS;EACT,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,yBAAyB;;EAEzB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,qCAAqC;EACrC,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,sBAAsB;EACtB,eAAe;EACf,uBAAuB;EACvB,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAiB;UAAjB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,yBAAyB;EACzB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,UAAU;EACV,2CAA2C;AAC7C;;AAEA;EACE,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;0BACwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ;IACE,YAAY;EACd;AACF;;AAEA;EACE,WAAW;EACX;IACE,YAAY,EAAE,qCAAqC;EACrD;AACF;;AAEA;EACE,sCAAsC,EAAE,qBAAqB;EAC7D,eAAe;EACf,cAAc,EAAE,yBAAyB;EACzC,mDAAmD;EACnD;;;;;;kCAMgC;EAChC,yDAAyD;AAC3D;;AAEA;EACE;IACE;;qCAEiC;EACnC;EACA;IACE;;qCAEiC;EACnC;AACF;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;;EAGE,SAAS;EACT,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,oBAAoB;EACpB,qBAAqB;EACrB,yBAAiB;UAAjB,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE;IACE,qBAAqB;IACrB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,kCAAkC;AAClC;EACE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,kCAAkC;AAClC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;EACA;IACE,UAAU;IACV,2BAA2B;EAC7B;AACF;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAiB;UAAjB,iBAAiB,EAAE,2BAA2B;EAC9C,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,qBAAqB,EAAE,yBAAyB;AAClD;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,2CAA2C;EAC3C,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,cAAc;EACd,oBAAoB;EACpB,yBAAiB;UAAjB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,UAAU;EACV,2CAA2C;AAC7C;;AAEA;;EAEE,UAAU;EACV,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,SAAS;EACT,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,wBAAwB;EACxB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;;EAEE,6BAA6B;EAC7B,YAAY;AACd","sourcesContent":["html,\nbody,\n#root {\n  margin: 0;\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  background-color: #282c34;\n}\n\n#root {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  min-height: 100vh;\n}\n\nmain {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2rem;\n  background-color: #282c34;\n\n  overflow-x: hidden;\n  overflow-y: auto;\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  box-sizing: border-box;\n  width: min(600px, calc(100vw - 2rem));\n  max-width: 600px;\n}\n\ntextarea,\ninput[type=\"text\"] {\n  box-sizing: border-box;\n  width: 340px;\n  height: 50px;\n  padding: 0;\n  margin: 0;\n  font-family: monospace;\n  font-size: 16px;\n  letter-spacing: 0.05rem;\n  color: white;\n  background-color: #282c34;\n  text-align: center;\n  line-height: 50px;\n  resize: none;\n  border: 1px solid white;\n  border-radius: 0.25rem;\n}\n\np {\n  font-family: monospace;\n  color: white;\n  margin: 0;\n  padding: 0;\n  line-height: normal;\n  word-break: break-all;\n  margin-left: 1rem;\n  margin-right: 1rem;\n  font-size: 1rem;\n}\n\nbutton {\n  font-size: 1rem;\n  font-family: monospace;\n  color: white;\n  background-color: #282c34;\n  border-radius: 0.25rem;\n  border-width: 1px;\n  border-color: white;\n  box-shadow: none;\n  padding-left: 1rem;\n  padding-right: 1rem;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  user-select: none;\n  transition: background-color 0.15s ease-in-out;\n}\n\nbutton:hover {\n  cursor: pointer;\n}\n\nbutton:not(.disabled):not(:disabled):hover {\n  background-color: #3a4150;\n}\n\nbutton:not(.disabled):not(:disabled):active {\n  border-style: inset;\n}\n\nbutton:focus-visible {\n  outline: 2px solid #61dafb;\n  outline-offset: 2px;\n}\n\nbutton.encrypt-btn {\n  border-radius: 999px;\n}\n\nbutton.encrypt-btn:not(.disabled) {\n  color: #282c34;\n  background-color: white;\n  border-color: white;\n}\n\nbutton.encrypt-btn:not(.disabled):not(:disabled):hover {\n  background-color: #e8e8e8;\n}\n\na {\n  color: white;\n}\n\nlabel {\n  font-size: 1rem;\n  color: white;\n  font-family: monospace;\n  display: flex;\n  flex-direction: row;\n  gap: 0.2rem;\n  align-items: center;\n  justify-content: center;\n}\n\n.secret-ready {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-self: stretch;\n  gap: 1.25rem;\n  width: 100%;\n  min-width: 0;\n}\n\n.secret {\n  position: relative;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  align-self: stretch;\n  width: 100%;\n  margin: 0;\n  background-color: #282c34;\n  border: 1px solid white;\n  padding-left: 2.75rem;\n  padding-right: 2.75rem;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n  text-align: center;\n  border-radius: 0.25rem;\n  font-family: monospace;\n  font-size: 1rem;\n  color: white;\n}\n\n.secret-value {\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.companion-message {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n  max-width: 100%;\n  color: white;\n  font-family: monospace;\n  font-size: 0.95rem;\n  line-height: 1.45;\n}\n\n.companion-message p {\n  margin: 0;\n  text-align: center;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\nbutton.message-copy-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.25rem;\n  height: 1.25rem;\n  padding: 0;\n  border: none;\n  background: transparent;\n  color: #8a919e;\n  font-size: 0.95rem;\n  line-height: 1;\n}\n\nbutton.message-copy-btn:not(:disabled):hover {\n  background-color: transparent;\n  color: white;\n}\n\nbutton.secret-eye-btn {\n  position: absolute;\n  right: 0.6rem;\n  top: 50%;\n  transform: translateY(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  padding: 0;\n  border: none;\n  border-radius: 0.25rem;\n  background-color: transparent;\n  color: white;\n  opacity: 0.7;\n  font-size: 1.1rem;\n  cursor: pointer;\n  transition: opacity 0.15s ease-in-out, background-color 0.15s ease-in-out;\n}\n\nbutton.secret-eye-btn:not(:disabled):hover {\n  opacity: 1;\n  background-color: rgba(255, 255, 255, 0.12);\n}\n\nbutton.secret-eye-btn:focus-visible {\n  opacity: 1;\n  outline: 2px solid #61dafb;\n  outline-offset: 1px;\n}\n\n.secret-lock-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n@keyframes lockJump {\n  0% {\n    transform: translateY(0);\n  }\n  40% {\n    transform: translateY(-7px);\n  }\n  70% {\n    transform: translateY(0);\n  }\n  85% {\n    transform: translateY(-2px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n\n.secret-lock-jump {\n  animation: lockJump 0.32s ease-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .secret-lock-jump {\n    animation: none;\n  }\n}\n\n.masked {\n  /* color: #8a919e;\n  border-color: #8a919e; */\n}\n\n.radio-group {\n  display: flex;\n  flex-direction: row;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.radio-group label.expiration {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.5rem 1rem;\n  border-width: 1px;\n  border-style: outset;\n  border-color: #8a919e;\n  border-radius: 999px;\n  background-color: #282c34;\n  color: #8a919e;\n  font-family: monospace;\n  font-size: 1rem;\n  cursor: pointer;\n  user-select: none;\n  transition: color 0.15s ease-in-out, border-color 0.15s ease-in-out;\n}\n\n.radio-group input[type=\"radio\"].expiration {\n  position: absolute;\n  opacity: 0;\n  pointer-events: none;\n  width: 0;\n  height: 0;\n}\n\n.radio-group label.expiration svg.time-joker {\n  fill: currentColor;\n}\n\n.radio-group label.expiration:has(input[type=\"radio\"]:checked) {\n  color: #282c34;\n  background-color: white;\n  border-color: white;\n  border-style: solid;\n}\n\n.radio-group label.expiration:has(input[type=\"radio\"]:focus-visible) {\n  outline: 2px solid #61dafb;\n  outline-offset: 2px;\n}\n\n@media (max-width: 768px) {\n  /* Tablets */\n  textarea {\n    width: 400px;\n  }\n}\n\n@media (max-width: 480px) {\n  /* Mobile */\n  textarea {\n    width: 300px; /* Full width on very small screens */\n  }\n}\n\n.back-to-future-title {\n  font-family: \"Press Start 2P\", cursive; /* Retro pixel font */\n  font-size: 2rem;\n  color: #f5f5f5; /* Light color for text */\n  /* text-shadow: 2px 2px 5px rgba(0, 0, 255, 0.2); */\n  /* text-shadow: 0 0 10px rgba(255, 255, 255, 0.8),\n    0 0 20px rgba(255, 255, 255, 0.6), 0 0 30px rgba(255, 255, 255, 0.4),\n    0 0 40px rgba(0, 255, 255, 0.6), 0 0 50px rgba(0, 255, 255, 0.4),\n    0 0 60px rgba(0, 255, 255, 0.2);\n  background: linear-gradient(45deg, #ff00ff, #00ffff, #ff0000);\n  background-clip: text;\n  -webkit-background-clip: text; */\n  /* animation: neon 1.5s ease-in-out infinite alternate; */\n}\n\n@keyframes neon {\n  0% {\n    text-shadow: 0 0 5px rgba(255, 255, 255, 0.8),\n      0 0 10px rgba(255, 255, 255, 0.6), 0 0 15px rgba(255, 255, 255, 0.4),\n      0 0 20px rgba(0, 255, 255, 0.6);\n  }\n  100% {\n    text-shadow: 0 0 20px rgba(255, 255, 255, 0.8),\n      0 0 30px rgba(255, 255, 255, 0.6), 0 0 40px rgba(255, 255, 255, 0.4),\n      0 0 50px rgba(0, 255, 255, 0.6);\n  }\n}\n\nh1 {\n  margin: 0;\n}\n\n.brand {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.tagline {\n  margin: 0;\n  font-family: monospace;\n  font-size: 0.9rem;\n  color: #8a919e;\n}\n\n.link-ready-copy {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.85rem;\n  margin-top: 1.25rem;\n}\n\n.link-ready-title,\n.link-ready-subtitle,\n.expires-after {\n  margin: 0;\n  font-family: monospace;\n  text-align: center;\n}\n\n.link-ready-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  color: white;\n  font-size: 1rem;\n}\n\n.link-ready-title svg {\n  color: #3dd68c;\n}\n\n.secret-ready-title svg {\n  color: inherit;\n}\n\n.link-ready-subtitle,\n.expires-after {\n  color: #8a919e;\n  font-size: 0.9rem;\n}\n\n.expires-after {\n  display: flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.link-ready {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-self: stretch;\n  gap: 1.25rem;\n  width: 100%;\n  min-width: 0;\n}\n\n.share-link {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 0.75rem;\n  box-sizing: border-box;\n  width: 100%;\n  min-width: 0;\n  padding: 0.75rem;\n  border: 1px solid white;\n  border-radius: 0.25rem;\n}\n\n.share-link-url {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  padding: 0 0.25rem;\n  color: white;\n  font-family: monospace;\n  font-size: 0.85rem;\n  line-height: 1.4;\n  text-align: left;\n  word-break: break-all;\n}\n\n.share-link-url svg {\n  flex-shrink: 0;\n  margin-top: 0.15rem;\n}\n\n.share-link button.encrypt-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n.copy-secret {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-self: stretch;\n  gap: 0.85rem;\n  width: 100%;\n}\n\n.retrieve-error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  align-self: stretch;\n  gap: 1rem;\n  width: 100%;\n  min-width: 0;\n}\n\n.retrieve-error-mark {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 3rem;\n  height: 3rem;\n  border: 1px solid #8a919e;\n  border-radius: 999px;\n  color: #c5cad3;\n  font-size: 1.15rem;\n}\n\n.retrieve-error-title {\n  margin: 0;\n  color: #f5f5f5;\n  font-family: monospace;\n  font-size: 1rem;\n  font-weight: 400;\n  text-align: center;\n}\n\n.retrieve-error-text {\n  max-width: 28rem;\n  margin: 0;\n  color: #8a919e;\n  font-family: monospace;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  text-align: center;\n  text-wrap: balance;\n  word-break: normal;\n  overflow-wrap: break-word;\n}\n\nbutton.retrieve-error-action {\n  align-self: center;\n  width: auto;\n  border-radius: 999px;\n  border-color: #8a919e;\n  background-color: #282c34;\n}\n\nbutton.create-another-btn,\nbutton.copy-secret-btn,\na.mailto-secret-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  align-self: stretch;\n  width: 100%;\n  border-radius: 999px;\n}\n\na.mailto-secret-btn {\n  box-sizing: border-box;\n  border-style: outset;\n  border-width: 1px;\n  border-color: white;\n  background-color: #282c34;\n  color: white;\n  font-family: monospace;\n  font-size: 1rem;\n  padding: 0.5rem 1rem;\n  text-decoration: none;\n  user-select: none;\n  transition: background-color 0.15s ease-in-out;\n}\n\na.mailto-secret-btn:hover {\n  background-color: #3a4150;\n}\n\na.mailto-secret-btn:focus-visible {\n  outline: 2px solid #61dafb;\n  outline-offset: 2px;\n}\n\n@keyframes scaleUpReveal {\n  0% {\n    transform: scale(0.9);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n/* Isolated class for the effect */\n.scale-up-reveal {\n  opacity: 0;\n  animation: scaleUpReveal 0.3s ease-in-out forwards;\n}\n\n@keyframes slideInLeft {\n  0% {\n    transform: translateX(-20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Isolated class for the effect */\n.slide-in-left {\n  opacity: 0;\n  animation: slideInLeft 0.3s ease-in-out forwards;\n}\n\n@keyframes slideInRight {\n  0% {\n    transform: translateX(20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Isolated class for the effect */\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes slideOutRight {\n  from {\n    opacity: 1;\n    transform: translateX(0);\n  }\n  to {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n}\n\n.slide-in-right {\n  animation: slideInRight 0.3s ease-in-out forwards;\n}\n\n.slide-out-right {\n  animation: slideOutRight 0.3s ease-in-out forwards;\n}\n\n.tiny-text {\n  font-size: 0.75rem;\n}\n\n.zoom-on-click {\n  user-select: none; /* Prevent text selection */\n  cursor: pointer;\n  transition: transform 0.2s ease-in-out;\n}\n\n.zoom-on-click:active {\n  transform: scale(1.1); /* Slight zoom on click */\n}\n\n.disabled {\n  pointer-events: none;\n  color: #8a919e;\n  border-color: #8a919e;\n}\n\n.button-group {\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n}\n\n.input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: stretch;\n  align-self: stretch;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.secret-fields {\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  width: 100%;\n}\n\n.input-wrapper textarea {\n  width: 100%;\n  min-width: 0;\n  height: calc(4 * 1.45em + 1.6rem + 2px);\n  min-height: calc(4 * 1.45em + 1.6rem + 2px);\n  padding: 0.8rem 2.6rem;\n  line-height: 1.45;\n  text-align: center;\n  resize: vertical;\n}\n\n.input-wrapper textarea:placeholder-shown,\n.input-wrapper textarea.single-line {\n  padding-top: calc((3 * 1.45em + 1.6rem) / 2);\n  padding-bottom: calc((3 * 1.45em + 1.6rem) / 2);\n}\n\n.input-wrapper:has(.input-clear-btn) textarea {\n  padding-left: 4.5rem;\n  padding-right: 4.5rem;\n}\n\n.message-field {\n  display: flex;\n  align-self: stretch;\n  width: 100%;\n}\n\n.message-field input[type=\"text\"] {\n  width: 100%;\n  min-width: 0;\n  height: 50px;\n  padding: 0 0.85rem;\n  line-height: 50px;\n}\n\n.char-count {\n  position: absolute;\n  right: 0;\n  bottom: calc(100% + 0.3rem);\n  font-family: monospace;\n  font-size: 0.7rem;\n  line-height: 1;\n  color: #8a919e;\n  pointer-events: none;\n  user-select: none;\n  white-space: nowrap;\n}\n\nbutton.input-clear-btn,\nbutton.input-dice-btn {\n  position: absolute;\n  top: 0.65rem;\n  transform: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  padding: 0;\n  border: none;\n  border-radius: 0.25rem;\n  background-color: transparent;\n  color: white;\n  opacity: 0.6;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: opacity 0.15s ease-in-out, background-color 0.15s ease-in-out;\n}\n\nbutton.input-dice-btn {\n  right: 0.4rem;\n}\n\nbutton.input-clear-btn {\n  right: 2.3rem;\n}\n\nbutton.input-clear-btn:not(:disabled):hover,\nbutton.input-dice-btn:not(:disabled):hover {\n  opacity: 1;\n  background-color: rgba(255, 255, 255, 0.12);\n}\n\nbutton.input-clear-btn:focus-visible,\nbutton.input-dice-btn:focus-visible {\n  opacity: 1;\n  outline: 2px solid #61dafb;\n  outline-offset: 1px;\n}\n\n.icon-button {\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 50px;\n  height: 50px;\n  padding: 0;\n  font-size: 1rem;\n  flex-shrink: 0;\n}\n\n.link {\n  width: 300px;\n}\n\n.recent-links {\n  align-self: stretch;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  width: 100%;\n}\n\n.recent-links-header {\n  display: flex;\n  align-items: baseline;\n  justify-content: flex-start;\n  gap: 1rem;\n}\n\n.recent-links h2 {\n  margin: 0;\n  color: #8a919e;\n  font-family: monospace;\n  font-size: 0.75rem;\n  font-weight: 400;\n  letter-spacing: 0.04em;\n}\n\n.recent-links ul {\n  display: flex;\n  flex-direction: column;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.recent-links li {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  min-height: 1.75rem;\n  color: white;\n  font-family: monospace;\n  font-size: 0.8rem;\n}\n\n.recent-time,\n.recent-expiration {\n  color: #8a919e;\n}\n\n.recent-time {\n  font-variant-numeric: tabular-nums;\n}\n\nbutton.recent-text-btn,\nbutton.recent-remove-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.3rem;\n  padding: 0.15rem 0.25rem;\n  border: none;\n  background: transparent;\n  color: #8a919e;\n  font-size: 0.75rem;\n  line-height: 1;\n}\n\nbutton.recent-remove-btn {\n  width: 1.25rem;\n  height: 1.25rem;\n  padding: 0;\n}\n\nbutton.recent-text-btn:not(:disabled):hover,\nbutton.recent-remove-btn:not(:disabled):hover {\n  background-color: transparent;\n  color: white;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
